import { authService } from '../../shared/services/auth.service';
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    // ValidationObserver,
    // ValidationProvider
  }
})
export default class Login extends Vue {

  public mounted() {
    //authService.login();
    this.redirect();
    this.reciveMessage();
  }

  public get logged() {
    return authService.username != null;
  }

  public get url() {
    return process.env.VUE_APP_SYMBINET_FRONT + '/call-back';
  }

  public reciveMessage() {
    document.getElementById('login-div')?.addEventListener('message',(message: any) => {//console.log(message)
    })
  }

  public redirect() {
    var iframe = document.getElementById('login-iframe') as HTMLIFrameElement;
    iframe.addEventListener('load', () => {
      var url = iframe.contentWindow?.location.href;
      if(url != undefined) {
        if(url == process.env.VUE_APP_SYMBINET_FRONT + '/main/home')
          window.location.href = url;
    }});
  }

}
